var r=function(r,t){return r.split(t)};export{r as getSplittedText};
